import {classNames, layout, MessageView, PushButton} from "@variocube/cube-ui";
import * as React from 'react';
import {useLocalization} from "../i18n";

export function CloseableMessage(props: { message: string; onClose: () => void }) {
    const {t} = useLocalization();
    return (
        <MessageView message={props.message}>
            <div className={classNames(layout.fill, layout.horizontal, layout.center)}>
                <PushButton primary onClick={props.onClose}>
                    {t("Close")}
                </PushButton>
            </div>
        </MessageView>
    );
}